<template>
  <div>
    <dashboard-page-title @addEvent="$router.push({name: 'addVideo'})" :showFilter="false" :showSearch="false" :showExportation="false">{{ $t('auth.videos') }}</dashboard-page-title>

    <main-table :fields="fields" :baseURL="VUE_APP_WEBSITE_LINK" :list_url="'admin/galleries/video'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_WEBSITE_LINK } from '@/config/constant'
export default {
  name: 'images',
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_WEBSITE_LINK,
      fields: [
        { label: 'العنوان', key: 'title', type: 'name', class: 'text-right' },
        { label: 'التفاصيل', key: 'content', class: 'text-right' },
        { label: 'عدد المشاهدات', key: 'views_count', type: 'number', class: 'text-right' },
        {
          label: 'التحكم',
          key: 'actions',
          class: 'text-right',
          type: 'actions',
          actions: [
            {
              text: 'edit',
              icon: 'ri-ball-pen-fill',
              color: 'info',
              ifNavigate: true,
              routePath: 'edit-video/:id'
            },
            {
              text: 'Delete',
              icon: 'ri-delete-bin-line',
              color: 'danger',
              url: 'admin/galleries',
              baseUrl: VUE_APP_WEBSITE_LINK,
              titleHeader: 'منتج',
              question: 'هل متأكد أنك تريد مسح هذا العنصر',
              textContent: 'name',
              textDeleteButton: 'بالتأكيد, مسح',
              textCancelButton: 'الغاء',
              showAlert: true
            }
          ]
        }
      ]
    }
  },
  methods: {

  }
}
</script>
